import { useMemo, useState } from 'react';
import { useContent } from '../App.jsx';
import PageHero from '../components/PageHero.jsx';
import { ArrowIcon, MenuIcon } from '../components/Icons.jsx';

export default function InstructorsPage() {
  const { content } = useContent();
  const instructors = content.instructors.filter((item) => item.visible);
  const disciplines = ['All', ...new Set(instructors.map((item) => item.discipline))];
  const [discipline, setDiscipline] = useState('All');
  const [selected, setSelected] = useState(null);
  const visible = useMemo(() => discipline === 'All' ? instructors : instructors.filter((item) => item.discipline === discipline), [discipline, instructors]);

  return (
    <>
      <PageHero eyebrow="2026 instructional staff" title="The best players. Generous teachers." body="Learn directly from decorated performers, musical leaders, and thoughtful educators from across the piping and drumming world." image={content.media.instructorsHero} imageAlt="Pocono Workshop instructional staff" />
      <section className="section page-width">
        <div className="filter-row" aria-label="Filter instructors by discipline">
          {disciplines.map((item) => <button className={item === discipline ? 'active' : ''} type="button" key={item} onClick={() => setDiscipline(item)}>{item}</button>)}
        </div>
        <div className="faculty-grid">
          {visible.map((instructor) => (
            <button className="faculty-card" type="button" key={instructor.id} onClick={() => setSelected(instructor)}>
              <div className="faculty-image"><img src={instructor.image} alt="" /><span>Read bio <ArrowIcon size={16} /></span></div>
              <p>{instructor.discipline}</p>
              <h2>{instructor.name}</h2>
            </button>
          ))}
        </div>
      </section>
      {selected && (
        <div className="modal-backdrop" role="presentation" onMouseDown={() => setSelected(null)}>
          <section className="faculty-modal" role="dialog" aria-modal="true" aria-labelledby="faculty-name" onMouseDown={(event) => event.stopPropagation()}>
            <button className="modal-close" type="button" onClick={() => setSelected(null)} aria-label="Close biography"><MenuIcon open /></button>
            <img src={selected.image} alt={selected.name} />
            <div><p className="eyebrow">{selected.discipline}</p><h2 id="faculty-name">{selected.name}</h2><p>{selected.bio}</p></div>
          </section>
        </div>
      )}
    </>
  );
}
